import React from "react";
import "./WhatsAppButton.css"; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp} from "@fortawesome/free-brands-svg-icons";
const WhatsAppButton = () => {
  const phoneNumber = "5493515295096"; 
  const message = encodeURIComponent("¡Hola! Estoy interesado en tus productos.");
  const whatsappURL = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a href={whatsappURL} className="whatsapp-button" target="_blank" rel="noopener noreferrer">
      <FontAwesomeIcon icon={faWhatsapp} className="whatsapp" />
    </a>
  );
};

export default WhatsAppButton;
